import React from 'react'
import { Box, Typography, Autocomplete, TextField } from '@mui/material'
import { makeStyles } from '../../../../utils/hooks/makeStyles'

const useStyles = makeStyles(() => ({
  container: {
    minWidth: 260,
  },
  label: {
    marginBottom: 0.5,
    display: 'block',
    color: 'text.secondary',
  },
}))

interface PaymentMethodSelectorProps {
  value: { label: string; value: string } | null
  onChange: (selectedOption: any) => void
  options: { label: string; value: string }[]
}

const PaymentMethodSelector: React.FC<PaymentMethodSelectorProps> = ({
  value,
  onChange,
  options,
}) => {
  const classes = useStyles()

  return (
    <Box className={classes.container}>
      <Typography variant='caption' className={classes.label}>
        Payment Method *
      </Typography>
      <Autocomplete
        value={value}
        onChange={(event, newValue) => onChange(newValue)}
        options={options}
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder='Select Payment Method'
            size='small'
          />
        )}
      />
    </Box>
  )
}

export default PaymentMethodSelector
